import { Image, Link } from '@com-delta-idp/mnx-ui-kit';
import { DisplayProperties } from '../../../models';

export interface RelatedLink extends Link {
  image: Image;
}

export interface RelatedLinks extends DisplayProperties {
  links: RelatedLink[];
}

export interface RelatedLinksAnalytics {
  action: Link;
  eventType: string;
}
